<template lang='pug'>
highcharts(:options="chartConfig")
</template>

<script>

export default {
  props: ['data', 'title'],
  data() {
    return {
      chartData: {}
    }
  },
  computed: {
    cumulativeRatings() {
      const ratings = this.chartData.ratings.data
      let cumulativeData = []
      for (let i = 0; i < ratings.length; i++) {
        const start = ((i === 0) ? 0 : cumulativeData[i-1][1])
        const newElement = [ratings[i][0], start + ratings[i][1]]
        cumulativeData.push(newElement);
      }
      return cumulativeData;
    },
    chartConfig() {
      const emptyClicks = this.chartData.clicks == null
      return {
        tooltip: {
          shared: true
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        yAxis: [
          {
            title: {
              text: 'Bewertungen',
              style: {color: '#7cb5ec'}
            },
            minorGridLineColor: '#f2f2f2',
            lineWidth: 1,
            gridLineColor: '#f2f2f2',
            min: 0
          },
          {
            title: {
              text: emptyClicks ? '' : 'Klicks',
              style: {color: '#f7a35c'}
            },
            minorGridLineColor: '#f2f2f2',
            gridLineColor: '#f2f2f2',
            lineWidth: 4,
            opposite: true,
            min: 0
          }
        ],
        xAxis: {
          type: 'datetime',
          crosshair: true
        },
        legend: { enabled: false },
        series: [{
          type: 'column',
          name: 'Bewertungen',
          data: this.cumulativeRatings,
          yAxis: 0,
          color: '#7cb5ec'
        },
        {
          data: emptyClicks ? [] : this.chartData.clicks.data,
          type: 'spline',
          name: 'Klicks',
          lineWidth: 4,
          yAxis: 1,
          color: '#f7a35c'
        },
        ]
      }
    }
  },
  created() {
    try {
      this.chartData = JSON.parse(this.data)
    } catch (e) {
      this.chartData = this.data
    }
  }
}
</script>

<style scoped>

</style>
